// TermsPage.js
const TermsPage = () => (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "auto", lineHeight: "1.6" }}>
        <h2>Terms and Conditions</h2>

        <p><strong>Last Updated:</strong> May 29, 2025</p>

        <p>
            Welcome to our AI-powered quiz generation platform. These Terms and Conditions ("Terms") govern your use of the platform and its services. By accessing or using our platform, you agree to be bound by these Terms. If you do not agree, you may not use the service.
        </p>

        <h3>1. Acceptance of Terms</h3>
        <p>
            By using this platform, you accept these Terms and our Privacy Policy. If you do not agree to any part of the Terms, please discontinue use.
        </p>

        <h3>2. Eligibility</h3>
        <p>
            You must be at least 13 years old to use this service. If you are under 18, you must have parental or guardian consent. If you are accessing this platform on behalf of an institution, you confirm that you have the authority to accept these Terms on its behalf.
        </p>

        <h3>3. Account and Security</h3>
        <p>
            You are responsible for keeping your account credentials confidential. You agree to notify us immediately if you suspect unauthorized access to your account.
        </p>

        <h3>4. Educational Use Only</h3>
        <p>
            This platform is intended for educational purposes only. It should be used as a study and revision aid by students or as a teaching tool by educators. Misuse of the tool to cheat or circumvent academic integrity rules is prohibited.
        </p>

        <h3>5. User Content</h3>
        <p>
            You may input text or content to generate quizzes. You retain ownership of this input, but you grant us a non-exclusive license to use it for the purpose of providing and improving our services.
        </p>

        <h3>6. AI-Generated Content</h3>
        <p>
            The platform uses artificial intelligence and natural language processing to generate quiz content. While we aim for accuracy, we do not guarantee that all content will be correct, complete, or appropriate. Use generated content with discretion.
        </p>

        <h3>7. Usage Restrictions</h3>
        <p>You agree not to:</p>
        <ul>
            <li>Use the platform for any unlawful or harmful purpose.</li>
            <li>Upload malicious code or disrupt platform functionality.</li>
            <li>Reverse-engineer, replicate, or distribute our software or services.</li>
        </ul>

        <h3>8. Intellectual Property</h3>
        <p>
            All platform content, features, and software are the intellectual property of the platform owners or its licensors. You may not reproduce, copy, or exploit any part without express written permission.
        </p>

        <h3>9. Privacy</h3>
        <p>
            We collect and process data as described in our Privacy Policy. By using the platform, you consent to the collection and use of data as outlined.
        </p>

        <h3>10. Service Availability</h3>
        <p>
            We aim to provide uninterrupted service but do not guarantee constant availability. Downtime may occur due to updates, technical issues, or force majeure.
        </p>

        <h3>11. Termination</h3>
        <p>
            We reserve the right to suspend or terminate your account at our discretion for violations of these Terms. You may also delete your account at any time.
        </p>

        <h3>12. Disclaimer</h3>
        <p>
            The platform is provided "as is" without warranties of any kind, express or implied. We are not responsible for academic outcomes or misuse of content.
        </p>

        <h3>13. Limitation of Liability</h3>
        <p>
            We are not liable for any indirect, incidental, or consequential damages resulting from the use or inability to use the platform.
        </p>

        <h3>14. Changes to Terms</h3>
        <p>
            We may revise these Terms at any time. Continued use after changes constitutes acceptance of the new Terms.
        </p>

        <h3>15. Contact Information</h3>
        <p>
            For questions or support, please contact us at: <a href="mailto:ylyn.org@gmail.com">ylyn.org@gmail.com</a>
        </p>
    </div>
);

export default TermsPage;
